module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-brewdog-6a163c8b0d83062654f56d7d319bcc58.png";